import {VehicleIncidentTypeEnum} from '@/services/api-clients';

export function vehicleIncidentTypeColorFilter(vehicleIncidentType: VehicleIncidentTypeEnum) {
  switch (vehicleIncidentType) {
    case VehicleIncidentTypeEnum.Crash: return 'red';
    case VehicleIncidentTypeEnum.Fee: return 'blue';
    case VehicleIncidentTypeEnum.Workshop: return 'indigo darken-4';
    case VehicleIncidentTypeEnum.ReceiveFromWorkshop: return 'indigo lighten-2';
    case VehicleIncidentTypeEnum.Failure: return 'orange';
    case VehicleIncidentTypeEnum.Other: return 'black';
    case VehicleIncidentTypeEnum.Convey: return 'blue accent-1';
    case VehicleIncidentTypeEnum.Return: return 'blue accent-1';
    case VehicleIncidentTypeEnum.TownTransfer: return 'green';
    case VehicleIncidentTypeEnum.Theft: return 'brown darken-2';
    case VehicleIncidentTypeEnum.BackToFleet: return 'purple';
    case VehicleIncidentTypeEnum.Maintain: return 'blue-grey';
    case VehicleIncidentTypeEnum.PeriodicVehicleInspection: return 'lime darken-1';
    default: return 'primary';
  }
}
